import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heart, Target, Eye } from 'lucide-react';
import { motion } from 'framer-motion';

const About: React.FC = () => {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <section id="sobre" className="section bg-brand-sand">
      <div className="wrapper">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={containerVariants}
          className="max-w-6xl mx-auto"
        >
          {/* Sobre a Luara */}
          <motion.div variants={itemVariants} className="mb-20">
            <div className="flex items-start gap-4 mb-8">
              <Heart className="w-8 h-8 text-brand-accent mt-1" />
              <h2 className="text-4xl md:text-5xl font-heading text-brand-slate">
                {t('about.title')}
              </h2>
            </div>
            <div className="card card-pad">
              <h3 className="text-2xl font-heading text-brand-slate mb-4">
                {t('about.who.title')}
              </h3>
              <p className="text-lg text-brand-ink leading-relaxed whitespace-pre-line">
                {t('about.who.text')}
              </p>
            </div>
          </motion.div>

          {/* Missão e Visão */}
          <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {/* Missão */}
            <div className="card card-pad">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-brand-accent rounded-full flex items-center justify-center">
                  <Target className="w-6 h-6 text-brand-sand" />
                </div>
                <h3 className="text-2xl font-heading text-brand-slate">{t('about.mission.title')}</h3>
              </div>
              <p className="text-brand-ink leading-relaxed text-lg">
                {t('about.mission.text')}
              </p>
            </div>

            {/* Visão */}
            <div className="card card-pad">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-brand-accent rounded-full flex items-center justify-center">
                  <Eye className="w-6 h-6 text-brand-sand" />
                </div>
                <h3 className="text-2xl font-heading text-brand-slate">{t('about.vision.title')}</h3>
              </div>
              <p className="text-brand-ink leading-relaxed text-lg">
                {t('about.vision.text')}
              </p>
            </div>
          </motion.div>

          {/* Propósito */}
          <motion.div variants={itemVariants}>
            <div className="card card-pad bg-brand-slate">
              <div className="flex items-center gap-4 mb-6">
                <h3 className="text-3xl font-heading text-brand-sand">{t('about.purpose.title')}</h3>
              </div>
              <div className="text-brand-sand/90 text-xl leading-relaxed font-medium italic">
                "{t('about.purpose.text')}"
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;